import React from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import type { LonnsomhetDelsumBase } from '@klp/prosjekt/services/types';
import { Amount } from '@klp/design/Amount';
import { useTranslation } from 'react-i18next';

type LonnsomhetTableRowSummaryProps = {
    data: LonnsomhetDelsumBase | undefined;
};

export const LonnsomhetTableRowSummary: React.FC<
    LonnsomhetTableRowSummaryProps
> = ({ data }) => {
    const { t } = useTranslation();
    return (
        <TableRow>
            <TableCell>{t('prosjekt.lonnsomhet.table.totalt')}</TableCell>
            <TableCell align="right">
                <Amount value={data?.kostnad ?? 0} />
            </TableCell>
            <TableCell />
            <TableCell />
            <TableCell align="right">
                <Amount value={data?.oktLeiePerAar ?? 0} round={false} />
            </TableCell>
            <TableCell align="right">
                <Amount value={data?.oktLeiePerM2PerAar ?? 0} round={false} />
            </TableCell>
            <TableCell />
        </TableRow>
    );
};
